import { cloneDeep }                                                   from 'lodash-es';
import { AddUserForm, ModalMode, ServerError, User, UsersState, View } from '@/views/users/users.types';
import { initialUserFormState }                                        from '@/views/users/users.variables';

const mutations = {
  toggleModal(state: UsersState, payload: boolean): void {
    state.modal.open = payload;
  },
  setUsers(state: UsersState, payload: User[]): void {
    state.users = payload;
  },
  setViewMode(state: UsersState, payload: View): void {
    state.view = payload;
  },
  setEditMode(state: UsersState, payload: ModalMode): void {
    state.modal.mode = payload;
  },
  setIsDataLoading(state: UsersState, payload: boolean): void {
    state.isDataLoading = payload;
  },
  setSelectedUserUuid(state: UsersState, payload: string): void {
    state.modal.form.selectedUuid = payload;
  },
  setFormInputs(state: UsersState, payload: Partial<AddUserForm>): void {
    state.modal.form.fields = { ...state.modal.form.fields, ...payload };
  },
  clearFormInputs(state: UsersState): void {
    state.modal.form.fields = cloneDeep(initialUserFormState);
  },
  setServerErrors(state: UsersState, serverErrors: ServerError[]): void {
    state.serverErrors = serverErrors;
  },
};

export default mutations;
